import { useLocation, Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main className="relative flex flex-col items-center justify-center px-4 py-28 text-center">
        <h1 className="pointer-events-none select-none font-heading text-[10rem] font-black leading-none text-accent-500/10 md:text-[14rem]">
          404
        </h1>
        <div className="relative z-10 -mt-10 md:-mt-16">
          <p className="font-heading text-2xl font-black text-foreground-950">这个新面孔档案不存在</p>
          <p className="mt-2 text-sm text-foreground-400">页面地址：{location.pathname}</p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-center">
            <Link to="/" className="btn bg-primary-500 text-background-50 hover:bg-primary-600">返回首页</Link>
            <Link to="/archives" className="btn border border-background-300 bg-background-100 text-foreground-700 hover:bg-background-200">
              去人物档案库
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}